import React, { useState, useEffect } from "react";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Loader from "./Loader";
import Image from "react-bootstrap/Image";

const SinglePage = props => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState({});

  const getPage = () => {
    const pageId = props.match.params.id;
    const getUrl = `http://admin.kapoff.se/wp-json/wp/v2/pages/${pageId}?_embed`;

    axios
      .get(getUrl)
      .then(res => {
        setPage(res.data);
        setIsLoaded(true);
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    getPage();
  }, [props.match.params.id]);

  if (isLoaded) {
    return (
      <Row>
        {page.featured_media !== 0 && (
          <Col xs="12">
            <Image
              src={
                page._embedded["wp:featuredmedia"][0].media_details.sizes[
                  "featured-large"
                ].source_url
              }
              fluid
            />
          </Col>
        )}
        <Col xs="12">
          <article className={"page " + page.id}>
            <h1>{page.title.rendered}</h1>
            <section
              className="content"
              dangerouslySetInnerHTML={{ __html: page.content.rendered }}
            ></section>
          </article>
        </Col>
      </Row>
    );
  }
  return (
    <Row>
      <Col xs="12" className="text-center mt-4">
        <Loader />
      </Col>
    </Row>
  );
};

export default SinglePage;



// WEBPACK FOOTER //
// ./src/components/SinglePage.jsx